import { Address } from '../components/HbtPortfolioManagementRequestOverview/components/HbtIndividualLoanDetails/types';

export const formatAddress = (address?: Address) => {
  return `${address?.unitNumber ?? ''} ${address?.streetNumber ?? ''} ${
    address?.streetName ?? ''
  } ${address?.streetTypeID ?? ''} ${address?.streetDirectionID ?? ''} ${
    address?.municipalityName ?? ''
  } ${address?.provinceID ?? ''} ${address?.postalCode ?? ''}`;
};
